var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppContentLayout',{staticClass:"alerts-view"},[_c('div',{staticClass:"top-section flex-centerize"},[_c('div',{staticClass:"top-section-content width-100"},[_c('AppTabs',{attrs:{"tabItems":_vm.tabItems}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }